<template>
    <div class="link-container" :style="border ? 'border: 1px solid rgba(220,223,230,0.8)' : 'border: none'">
        <custom-select
          v-model="valueModel"
          placeholder="请选择"
          :options="getOptions()"
          style="width: fit-content; color: #697B8C; margin-left: 10px"
          @change="setType"
        >
        </custom-select>
        <week-date-picker :type="valueModel" v-if="['date','week','month'].indexOf(valueModel)>-1" @change="setValue" v-model="dateVal"></week-date-picker>
        <time-range v-if="valueModel==='time'" @change="setValue" v-model="dateVal"/>
        <week-date-picker1 :type="valueModel" v-if="['dateOnly','weekOnly','monthOnly'].indexOf(valueModel)>-1" @change="setValue" v-model="dateVal"></week-date-picker1>
        <week-date-picker2 :type="valueModel" v-if="['date2','week2','month2','businessWeek'].indexOf(valueModel)>-1" @change="setValue" v-model="dateVal"></week-date-picker2>

        
    </div>
</template>
<script>
import WeekDatePicker from './weekDatePicker.vue'
import TimeRange from './timeRange.vue'
import WeekDatePicker1 from './weekDatePicker1.vue'
import WeekDatePicker2 from './weekDatePicker2.vue'
import CustomSelect from "@/components/customSelect/index.vue";


export default{
    name:"LinkSelect",
    components:{CustomSelect, WeekDatePicker,TimeRange,WeekDatePicker1,WeekDatePicker2 },
    props:{
        firstOptions:{
            type:Array,
            default:[]
        },
        value:{
            type:String,
            default:""
        },
      border:{
        type:Boolean,
        default:true
      },
    },
    data(){
        return {
            valueModel:"",
            type:'',
            dateVal:[],
        }
    },
    created() {
      

    },
    watch:{
        value:{
            handler(v){
                this.valueModel = _.cloneDeep(v['left'])
                this.dateVal = _.cloneDeep(v['right'])
            },
            immediate: true,
            deep: true
        },
    },
    methods:{
        setType(v){
          if(v==='dateOnly'){
            this.$emit("input", {left:v,right:''})
            this.$emit("change", {left:v,right:''})
          }else if(v==='monthOnly'){
            this.$emit("input", {left:v,right:''})
            this.$emit("change", {left:v,right:''})
          }else if(v==='weekOnly'){
            this.$emit("input", {left:v,right:''})
            this.$emit("change", {left:v,right:''})
          }else{
            this.$emit("input", {left:v,right:[]})
            this.$emit("change", {left:v,right:[]})
          }
          
        },
        setValue(v){
            this.$emit("input", {left:this.valueModel,right:v})
            this.$emit("change", {left:this.valueModel,right:v})
        },
        getOptions(){
          let resData = [
            {
              label: "按日",
              value: "date",
            },
            {
              label: "按周",
              value: "week",
            },
            {
              label: "按月",
              value: "month",
            },
            {
              label: "时间段",
              value: "time",
            },
            {
              label:'按日',
              value:'dateOnly'
            },
            {
              label:'按周',
              value:'weekOnly'
            },
            {
              
              label:"按月",
              value:"monthOnly"
            },
            {
              label:'按日',
              value:'date2'
            },
            {
              label:'按周',
              value:'week2'
            },
            {
              
              label:"按月",
              value:"month2"
            },
            {
              label:"按业务周",
              value:"businessWeek"
            }
            
          ]
          if(!this.$tool.empty(this.firstOptions)){
            resData = resData.filter(item=> this.firstOptions.indexOf(item.value) > -1)
          }
          return resData

        }
    }
}
</script>
<style lang="less" scoped>
.link-container {
  display: flex;
  flex-direction: row;
  align-items: center;
  border-radius: 4px;
  background: #fff
}
.select-style {


}
::v-deep .el-input__inner{
  border: none;
}
</style>